// Porosity: presentational coin flights (no game state is touched).
//   flyCoins: an arced flight of coins between two anchors (payments, income).
import { coinSvgMarkup } from "@/components/game/Coin";

const LAYER_ID = "porosity-coin-fx-layer";

function ensureLayer() {
  let layer = document.getElementById(LAYER_ID);
  if (!layer) {
    layer = document.createElement("div");
    layer.id = LAYER_ID;
    Object.assign(layer.style, { position: "fixed", inset: "0", pointerEvents: "none", zIndex: "9999", overflow: "visible" });
    document.body.appendChild(layer);
  }
  return layer;
}

function anchorEl(anchor) {
  const el = typeof anchor === "string" ? document.querySelector(anchor) : anchor;
  if (!el || !el.getBoundingClientRect) return null;
  const r = el.getBoundingClientRect();
  return r.width === 0 && r.height === 0 ? null : r;
}

const centre = (r) => r && { x: r.left + r.width / 2, y: r.top + r.height / 2 };

// The overlay lives outside the scaled stage, so sizes follow the stage scale.
const stageScale = () => parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--stage-scale")) || 1;

function makeCoinEl(baseSize, x, y) {
  const size = baseSize * stageScale();
  const el = document.createElement("div");
  el.innerHTML = coinSvgMarkup(size);
  Object.assign(el.style, {
    position: "fixed",
    left: `${x - size / 2}px`,
    top: `${y - size / 2}px`,
    opacity: "0",
    willChange: "transform, opacity",
    pointerEvents: "none",
  });
  return el;
}

const done = (anim, el) => {
  anim.onfinish = () => el.remove();
  anim.oncancel = () => el.remove();
};

export function flyCoins({ from, to, count = 1, stagger = 150, flight = 2400, arcHeight = 60, size = 15 }) {
  const src = centre(anchorEl(from));
  const dst = centre(anchorEl(to));
  if (!src || !dst) return;
  const layer = ensureLayer();
  const n = Math.max(1, Math.min(count, 6));
  const dx = dst.x - src.x;
  const dy = dst.y - src.y;
  const arc = -Math.max(20, Math.min(arcHeight, Math.hypot(dx, dy) * 0.28));

  for (let i = 0; i < n; i++) {
    const el = makeCoinEl(size, src.x, src.y);
    const jitter = n === 1 ? 0 : (i - (n - 1) / 2) * 9;
    layer.appendChild(el);
    const kf = [
      { transform: "translate(0px, 0px)", opacity: 0, offset: 0 },
      { transform: `translate(${jitter}px, ${arc * 0.35}px)`, opacity: 1, offset: 0.15 },
      { transform: `translate(${dx * 0.5 + jitter * 0.5}px, ${dy * 0.5 + arc}px)`, opacity: 1, offset: 0.55 },
      { transform: `translate(${dx}px, ${dy}px)`, opacity: 1, offset: 0.92 },
      { transform: `translate(${dx}px, ${dy}px) scale(0.6)`, opacity: 0, offset: 1 },
    ];
    done(el.animate(kf, { duration: flight, delay: i * stagger, easing: "cubic-bezier(0.4, 0, 0.3, 1)", fill: "forwards" }), el);
  }
}
